<ng-template #progressSpinnerRef>
	<mat-progress-spinner
		[diameter]="diameter"
		[mode]="mode"
		[color]="color"
	></mat-progress-spinner>
</ng-template>
